(() => {
  const dialog = document.querySelector('[data-book-notify-dialog]');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const labels = JSON.parse(document.querySelector('[data-notify-labels]').textContent);
  const title = dialog.querySelector('[data-notify-title]');
  const bookField = dialog.querySelector('[data-notify-book]');
  const idField = dialog.querySelector('[data-notify-id]');
  const message = dialog.querySelector('[data-notify-message]');
  const returnField = dialog.querySelector('[data-notify-return]');
  const email = dialog.querySelector('[type="email"]');
  const submit = dialog.querySelector('[data-notify-submit]');
  const submitLabel = submit?.textContent;
  let opener;
  let selected;
  let sending = false;
  const acceptedAlerts = new Set();
  const originalError = dialog.querySelector('[data-notify-api-error]').textContent;
  const storageKey = 'moharni-book-notification';
  let stopCelebration = () => {};
  function celebrateSignup() {
    stopCelebration();
    const canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.setAttribute('popover', 'manual');
    canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;max-width:none;max-height:none;margin:0;padding:0;border:0;background:transparent;pointer-events:none;z-index:2147483647;';
    document.body.append(canvas);
    if (canvas.showPopover) canvas.showPopover();
    else dialog.append(canvas);
    const context = canvas.getContext('2d');
    if (!context) { canvas.remove(); return; }
    const width = innerWidth, height = innerHeight;
    const scale = Math.min(devicePixelRatio || 1, 2);
    canvas.width = width * scale; canvas.height = height * scale;
    context.scale(scale, scale);
    const colors = ['#2153dc', '#dd247b', '#ffbd24', '#2a9c57', '#70d7ee', '#fff3bc'];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const particles = Array.from({length: reduced ? 65 : 380}, (_, i) => ({
      x: reduced ? Math.random() * width : (i % 2 ? width * .12 : width * .88),
      y: reduced ? Math.random() * height : height * .7,
      vx: (i % 2 ? 1 : -1) * (2 + Math.random() * 13),
      vy: -12 - Math.random() * 17,
      size: 7 + Math.random() * 9,
      angle: Math.random() * Math.PI,
      spin: (Math.random() - .5) * .25,
      delay: reduced ? 0 : Math.floor(i / 130) * 230,
      color: colors[i % colors.length],
      star: i % 9 === 0
    }));
    let frame, started, last;
    function finish() { cancelAnimationFrame(frame); canvas.remove(); }
    stopCelebration = finish;
    function draw(now) {
      if (started === undefined) { started = now; last = now; }
      const elapsed = now - started;
      const step = Math.min((now - last) / 16.67, 2); last = now;
      context.clearRect(0, 0, width, height);
      context.globalAlpha = Math.min(1, (reduced ? 1100 - elapsed : 5000 - elapsed) / 650);
      particles.forEach(p => {
        if (elapsed < p.delay) return;
        if (!reduced) { p.x += p.vx * step; p.y += p.vy * step; p.vy += .23 * step; p.vx *= Math.pow(.992, step); p.angle += p.spin * step; }
        context.save(); context.translate(p.x, p.y); context.rotate(p.angle); context.fillStyle = p.color;
        if (p.star) {
          context.beginPath();
          for (let n = 0; n < 10; n++) { const radius = n % 2 ? p.size * .35 : p.size; const angle = n * Math.PI / 5; context.lineTo(Math.cos(angle) * radius, Math.sin(angle) * radius); }
          context.closePath(); context.fill();
        } else context.fillRect(-p.size / 2, -p.size / 3, p.size, p.size * .65);
        context.restore();
      });
      if (elapsed < (reduced ? 1100 : 5000) && dialog.open) frame = requestAnimationFrame(draw);
      else finish();
    }
    frame = requestAnimationFrame(draw);
  }
  function remember(value) {
    try { sessionStorage.setItem(storageKey, JSON.stringify(value)); } catch {}
  }
  function restore() {
    try { return JSON.parse(sessionStorage.getItem(storageKey)); } catch { return null; }
  }
  function choose(book) {
    selected = book;
    title.textContent = book.title;
    const bundleList = dialog.querySelector('[data-notify-bundle-books]');
    const bundleBooks = book.ids ? JSON.parse(document.querySelector('[data-planned-catalog]').textContent).books.filter(item => book.ids.includes(item.id)) : [];
    bundleList.replaceChildren();
    bundleList.hidden = !book.ids;
    bundleBooks.forEach(item => { const li = document.createElement('li'); li.textContent = item.title; bundleList.append(li); });
    dialog.querySelector('[data-notify-privacy-label]').textContent = book.ids ? labels.bundle_privacy : labels.privacy;
    dialog.querySelector('[data-notify-consent-label]').textContent = book.ids ? labels.bundle_consent : labels.consent;
    dialog.querySelector('[data-notify-success-heading]').textContent = book.ids ? labels.bundle_success_heading : labels.success_heading;
    dialog.querySelector('[data-notify-success-body]').textContent = book.ids ? labels.bundle_success_body : labels.success_body;
    dialog.querySelector('[data-notify-api-error]').textContent = book.ids ? labels.bundle_error : originalError;
    if (bookField) bookField.value = book.title;
    if (idField) idField.value = book.id;
    if (message) message.value = labels.message.replace('{title}', book.title).replace('{id}', book.id);
    if (returnField) {
      const url = new URL(location.href);
      ['contact_posted', 'form_type'].forEach(key => url.searchParams.delete(key));
      url.searchParams.set('ma_notify', book.id);
      url.searchParams.set('contact_posted', 'true');
      returnField.value = `${url.pathname}${url.search}#BookAvailabilityForm`;
    }
  }
  function open(book, trigger) {
    if (sending) return;
    stopCelebration();
    opener = trigger;
    dialog.querySelector('[data-notify-success]')?.setAttribute('hidden','');
    dialog.querySelector('[data-notify-error]')?.setAttribute('hidden','');
    dialog.querySelector('[data-notify-fields]').hidden = false;
    dialog.querySelector('[type="checkbox"]').checked = false;
    dialog.querySelector('[data-notify-api-success]')?.setAttribute('hidden','');
    dialog.querySelector('[data-notify-api-error]')?.setAttribute('hidden','');
    choose(book);
    if (submit) { submit.disabled = false; submit.removeAttribute('aria-busy'); }
    if (submit) submit.textContent = submitLabel;
    if (!dialog.open) dialog.showModal();
    email?.focus();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-book-notify]');
    if (!button) return;
    event.preventDefault();
    const book = {id:button.dataset.bookId, title:button.dataset.bookTitle, ...(button.dataset.bookIds ? {ids:button.dataset.bookIds.split(',')} : {})};
    if (!book.id || !book.title) return;
    open(book, button);
  });
  dialog.querySelectorAll('[data-notify-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { stopCelebration(); if (opener?.isConnected) opener.focus({preventScroll:true}); });
  form?.addEventListener('submit', async event => {
    if (!selected || !form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
    if (sending) { event.preventDefault(); return; }
    const company = dialog.dataset.klaviyoCompany;
    const catalog = document.querySelector('[data-planned-catalog]');
    const catalogBooks = catalog ? JSON.parse(catalog.textContent).books : [];
    const books = (selected.ids || [selected.id]).map(id => catalogBooks.find(item => item.id === id));
    if (!company) { remember(selected); } else { event.preventDefault(); }
    sending = true;
    if (submit) { submit.disabled = true; submit.setAttribute('aria-busy','true'); }
    if (submit) submit.textContent = labels.busy;
    if (!company) return;
    const error = dialog.querySelector('[data-notify-api-error]');
    error.hidden = true;
    try {
      if (!books.length || books.some(book => !book?.variant_id)) throw new Error('Missing book variant');
      for (const book of books) {
      const alertKey = `${email.value.trim().toLowerCase()}:${book.variant_id}`;
      if (acceptedAlerts.has(alertKey)) continue;
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(company)}`, {
        method: 'POST', headers: {'Content-Type':'application/json', revision:'2024-06-15'},
        body: JSON.stringify({data:{type:'back-in-stock-subscription',attributes:{profile:{data:{type:'profile',attributes:{email:email.value.trim()}}},channels:['EMAIL']},relationships:{variant:{data:{type:'catalog-variant',id:`$shopify:::$default:::${book.variant_id}`}}}}})
      });
      if (response.status !== 202) throw new Error(`Subscription rejected (${response.status})`);
      acceptedAlerts.add(alertKey);
      }
      dialog.querySelector('[data-notify-fields]').hidden = true;
      const success = dialog.querySelector('[data-notify-api-success]');
      success.hidden = false;
      success.focus();
      try { celebrateSignup(); } catch { stopCelebration(); }
    } catch {
      error.hidden = false;
      error.focus();
    } finally { resetSending(); }
  });
  function resetSending() {
    sending = false;
    if (submit) { submit.disabled = false; submit.removeAttribute('aria-busy'); }
    if (submit) submit.textContent = submitLabel;
  }
  resetSending();
  window.addEventListener('pageshow', resetSending);
  const returnedId = new URL(location.href).searchParams.get('ma_notify');
  const returned = returnedId || location.hash === '#BookAvailabilityForm';
  if (returned) {
    let book = restore();
    if (returnedId && book?.id !== returnedId) book = null;
    const data = document.querySelector('[data-planned-catalog]');
    if (!book && data && returnedId) book = JSON.parse(data.textContent).books.find(item => item.id === returnedId);
    if (book) choose(book);
    else title.textContent = labels.unselected;
    if (dialog.querySelector('[data-notify-success], [data-notify-error]')) {
      dialog.showModal();
      dialog.querySelector('[data-notify-close]').focus();
    }
  }
})();
